// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_container__SjpRI {
  display: grid;
  grid-template-columns: 5.8fr 4.2fr;
  max-width: 100vw;
}
@media only screen and (max-width: 56.25em) {
  .Login_container__SjpRI {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }
}

.Login_leftside__FS9NJ {
  display: grid;
  row-gap: 2rem;
  background-color: var(--color-light);
  grid-template-rows: 3.8rem min-content;
  padding: 3rem 10rem 0 10rem;
  align-content: center;
}

.Login_logo__VaYjm {
  height: 3.8rem;
}
@media only screen and (max-width: 56.25em) {
  .Login_logo__VaYjm {
    margin-top: 5rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Login_logo__VaYjm {
    justify-self: center;
  }
}

.Login_slider__5QHiN {
  display: grid;
  grid-template-rows: 32.8rem repeat(3, max-content);
  row-gap: 2.5rem;
}
@media only screen and (max-width: 56.25em) {
  .Login_slider__5QHiN {
    margin-top: 10rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Login_slider__5QHiN {
    margin-top: 20rem;
    display: flex;
    flex-direction: column;
  }
}
.Login_slider__img__WIdf- {
  height: 32.8rem;
  justify-self: center;
  grid-column: 1/span 1;
  grid-row: 1/span 1;
}
.Login_slider__title__0q4pM {
  color: var(--color-primary);
  font-size: var(--default-font-h3);
  font-weight: 700;
}
@media only screen and (max-width: 56.25em) {
  .Login_slider__title__0q4pM {
    text-align: center;
  }
}
@media only screen and (max-width: 31.25em) {
  .Login_slider__title__0q4pM {
    font-size: var(--default-font-subtitle);
    color: var(--color-dark);
    font-weight: 400;
    text-align: center;
  }
}
.Login_slider__icon__dKsrN {
  display: flex;
}
.Login_slider__icon__default__tKz63 {
  content: "";
  background-color: var(--color-primary);
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  margin-right: 1rem;
}
.Login_slider__icon__outline__-02XF {
  content: "";
  border: 1px solid var(--color-primary);
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  margin-right: 1rem;
}

.Login_rightside__nhkW7 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--color-white);
  min-height: 100vh;
  padding-top: 2rem;
  padding-bottom: 2rem;
}
@media only screen and (max-width: 56.25em) {
  .Login_rightside__nhkW7 {
    background-color: var(--color-light);
    min-height: auto;
  }
}
.Login_rightside__back__W5kq5 {
  display: flex;
  align-items: center;
  font-size: 4.5rem;
  color: var(--color-primary);
  margin: 2rem 0;
  cursor: pointer;
}
.Login_rightside__back__W5kq5:hover {
  color: var(--color-primary-4);
}

.Login_logintext__center__DbD-L {
  text-align: center;
}
.Login_logintext__title__0DSKp {
  font-size: var(--default-font-subtitle);
  font-weight: 700;
  color: var(--color-primary);
  line-height: 3rem;
}
.Login_logintext__p__wb-Oy {
  font-size: var(--default-font-small);
  font-weight: 400;
  line-height: 1.7rem;
  margin-top: 2rem;
  margin-bottom: 3rem;
}

.Login_form__-A4-1 {
  display: block;
}
.Login_form__group__zG\\+o7:not(:last-child) {
  margin-bottom: 1rem;
}
.Login_form__pin__input__MQfFP {
  font-size: var(--default-font-size);
  font-family: inherit;
  color: var(--color-grey);
  width: 6rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid var(--color-dark);
  display: block;
  text-align: center;
}
.Login_form__pin__input__MQfFP:focus, .Login_form__pin__input__MQfFP:focus-visible, .Login_form__pin__input__MQfFP:focus-within {
  color: var(--color-dark);
  border: 1px solid var(--color-primary);
}
.Login_form__input__jOQyW {
  font-size: var(--default-font-size);
  font-family: inherit;
  color: var(--color-grey);
  padding-left: 2rem;
  width: 38rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid var(--color-dark);
  display: block;
}
.Login_form__input__jOQyW:focus, .Login_form__input__jOQyW:focus-visible, .Login_form__input__jOQyW:focus-within {
  color: var(--color-dark);
  border: 1px solid var(--color-primary);
}
.Login_form__label__r9UNY {
  font-size: var(--default-font-small);
  font-family: inherit;
  padding-left: 2rem;
}

.Login_filled__w6sCg {
  color: var(--color-dark);
}

.Login_otp__group__1dHw7 {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
}

button {
  font-family: "Montserrat", sans-serif;
  font-size: var(--default-font-size);
  display: flex;
  background-color: transparent;
  border: none;
}

.Login_btn__rkmne {
  padding: 1.9rem 2.2rem;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-weight: 700;
  border-radius: 1rem;
  cursor: pointer;
}
.Login_btn__outline__584VG {
  border: 1px solid var(--color-dark);
  margin-right: 2.3rem;
  color: var(--color-dark);
}
.Login_btn__outline__584VG:hover {
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
}
.Login_btn__default__NHTqN {
  background-color: var(--color-primary)-2;
  color: var(--color-white);
}
.Login_btn__default__NHTqN:hover {
  background-color: var(--color-primary)-4;
}
.Login_btn__default_38__eMqt6 {
  background-color: var(--color-primary)-2;
  color: var(--color-white);
  width: 38rem;
}
.Login_btn__default_38__eMqt6:hover {
  background-color: var(--color-primary)-4;
}
.Login_btn__icon__1VNGL {
  height: 2.2rem;
  margin-right: 1rem;
}
.Login_btn__form__PU5Hx {
  background-color: var(--color-primary)-2;
  color: var(--color-white);
  width: 100%;
  margin-top: 2rem;
}
.Login_btn__form__PU5Hx:hover {
  background-color: var(--color-primary)-4;
}

.Login_accent__Q9jN6 {
  font-size: var(--default-font-small);
  font-weight: 700;
  text-align: end;
  cursor: pointer;
}

.Login_clickable__Q\\+uUi {
  color: var(--color-primary);
  cursor: pointer;
}

.Login_emphasized__EBSzU {
  color: var(--color-primary);
  font-size: var(--default-font-size);
}

.Login_color__primary__Eifid {
  color: var(--color-primary);
}

.Login_mt_40__pCmrf {
  margin-top: 4rem;
}

.Login_mt_30__HAf0E {
  margin-top: 3rem;
}

.Login_mb_30__dKnxY {
  margin-bottom: 3rem;
}

.Login_mb_10__mYSNi {
  margin-bottom: 1rem;
}

.Login_error__TObdD {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
  max-width: 38rem;
}

.Login_success__h3__89soV {
  color: var(--color-success);
  font-size: var(--default-font-h3);
  font-weight: 700;
  line-height: 3.5rem;
}

.Login_pw__img__FFZWs {
  max-width: 25rem;
}

.Login_account__DDsxO {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Login_account__DDsxO > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Login_account__owner__pfifW {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Login_account__owner_b__jr\\+35 {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Login_account__employee__D4DJD {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Login_account__employee_b__GFTDs {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Login_account__desc__tPTFg {
  font-size: var(--default-font-small);
  width: 38rem;
  text-align: center;
  margin-bottom: 3rem;
}
.Login_account__desc__tPTFg span {
  font-weight: 700;
  color: var(--color-primary);
}

input:disabled {
  cursor: not-allowed;
  background-color: var(--color-grey-3);
}

.Login_checkbox__QdBqA {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 100%;
}
.Login_checkbox__group__fMZqQ {
  align-self: center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Login/Login.module.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;EACA,kCAAA;EACA,gBAAA;AAFD;AAIC;EALD;IAME,aAAA;IACA,sBAAA;IACA,SAAA;EADA;AACF;;AAKA;EACC,aAAA;EACA,aAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,qBAAA;AAFD;;AAKA;EACC,cAAA;AAFD;AAGC;EAFD;IAGE,gBAAA;EAAA;AACF;AACC;EALD;IAME,oBAAA;EAEA;AACF;;AACA;EACC,aAAA;EACA,kDAAA;EACA,eAAA;AAED;AADC;EAJD;IAKE,iBAAA;EAIA;AACF;AAFC;EARD;IASE,iBAAA;IACA,aAAA;IACA,sBAAA;EAKA;AACF;AAHC;EACC,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;AAKF;AAFC;EACC,2BAAA;EACA,iCAAA;EACA,gBAAA;AAIF;AAFE;EALD;IAME,kBAAA;EAKD;AACF;AAJE;EARD;IASE,uCAAA;IACA,wBAAA;IACA,gBAAA;IACA,kBAAA;EAOD;AACF;AAJC;EACC,aAAA;AAMF;AAJE;EACC,WAAA;EACA,sCAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAMH;AAHE;EACC,WAAA;EACA,sCAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAKH;;AACA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAED;AAAC;EAVD;IAWE,oCAAA;IACA,gBAAA;EAGA;AACF;AADC;EACC,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AAGF;AADE;EACC,6BAAA;AAGH;;AAGC;EACC,kBAAA;AAAF;AAGC;EACC,uCAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AADF;AAIC;EACC,oCAAA;EACA,gBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAQA;EACC,cAAA;AALD;AAOC;EACC,mBAAA;AALF;AAQC;EACC,mCAAA;EACA,oBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;AANF;AAQE;EAGC,wBAAA;EACA,sCAAA;AARH;AAYC;EACC,mCAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,mCAAA;EACA,cAAA;AAVF;AAYE;EAGC,wBAAA;EACA,sCAAA;AAZH;AAgBC;EACC,oCAAA;EACA,oBAAA;EACA,kBAAA;AAdF;;AAoBA;EACC,wBAAA;AAjBD;;AAqBA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AAlBD;;AAsBA;EACC,qCAAA;EACA,mCAAA;EACA,aAAA;EACA,6BAAA;EACA,YAAA;AAnBD;;AAsBA;EACC,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAnBD;AAqBC;EACC,mCAAA;EACA,oBAAA;EACA,wBAAA;AAnBF;AAqBE;EACC,sCAAA;EACA,2BAAA;AAnBH;AAuBC;EACC,wCAAA;EACA,yBAAA;AArBF;AAuBE;EACC,wCAAA;AArBH;AAyBC;EACC,wCAAA;EACA,yBAAA;EACA,YAAA;AAvBF;AAyBE;EACC,wCAAA;AAvBH;AA2BC;EACC,cAAA;EACA,kBAAA;AAzBF;AA4BC;EACC,wCAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AA1BF;AA4BE;EACC,wCAAA;AA1BH;;AA+BA;EACC,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AA5BD;;AA+BA;EACC,2BAAA;EACA,eAAA;AA5BD;;AA+BA;EACC,2BAAA;EACA,mCAAA;AA5BD;;AAgCA;EACC,2BAAA;AA7BD;;AAiCA;EACC,gBAAA;AA9BD;;AAiCA;EACC,gBAAA;AA9BD;;AAiCA;EACC,mBAAA;AA9BD;;AAiCA;EACC,mBAAA;AA9BD;;AAmCA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAhCD;;AAqCC;EACC,2BAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;AAlCF;;AAuCA;EACC,gBAAA;AApCD;;AAuCA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AArCD;AAuCC;EACC,sBAAA;EACA,kBAAA;AArCF;AAwCC;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAtCF;AAwCE;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAtCH;AA0CC;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAxCF;AA0CE;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAxCH;AA4CC;EACC,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AA1CF;AA4CE;EACC,gBAAA;EACA,2BAAA;AA1CH;;AAgDA;EACC,mBAAA;EACA,qCAAA;AA7CD;;AAiDA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;AA9CD;AAgDC;EACC,kBAAA;EACA,WAAA;AA9CF","sourcesContent":["@import '../variables/breakpoints';\n\n//Styling the container\n.container {\n\tdisplay: grid;\n\tgrid-template-columns: 5.8fr 4.2fr;\n\tmax-width: 100vw;\n\n\t@media only screen and (max-width: 56.25em) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 3rem;\n\t}\n}\n\n// Styling the left side\n.leftside {\n\tdisplay: grid;\n\trow-gap: 2rem;\n\tbackground-color: var(--color-light);\n\tgrid-template-rows: 3.8rem min-content;\n\tpadding: 3rem 10rem 0 10rem;\n\talign-content: center;\n}\n\n.logo {\n\theight: 3.8rem;\n\t@media only screen and (max-width: 56.25em) {\n\t\tmargin-top: 5rem;\n\t}\n\t@media only screen and (max-width: 31.25em) {\n\t\tjustify-self: center;\n\t}\n}\n\n.slider {\n\tdisplay: grid;\n\tgrid-template-rows: 32.8rem repeat(3, max-content);\n\trow-gap: 2.5rem;\n\t@media only screen and (max-width: 56.25em) {\n\t\tmargin-top: 10rem;\n\t}\n\n\t@media only screen and (max-width: 31.25em) {\n\t\tmargin-top: 20rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t&__img {\n\t\theight: 32.8rem;\n\t\tjustify-self: center;\n\t\tgrid-column: 1 / span 1;\n\t\tgrid-row: 1 / span 1;\n\t}\n\n\t&__title {\n\t\tcolor: var(--color-primary);\n\t\tfont-size: var(--default-font-h3);\n\t\tfont-weight: 700;\n\n\t\t@media only screen and (max-width: 56.25em) {\n\t\t\ttext-align: center;\n\t\t}\n\t\t@media only screen and (max-width: 31.25em) {\n\t\t\tfont-size: var(--default-font-subtitle);\n\t\t\tcolor: var(--color-dark);\n\t\t\tfont-weight: 400;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\n\t\t&__default {\n\t\t\tcontent: '';\n\t\t\tbackground-color: var(--color-primary);\n\t\t\theight: 2rem;\n\t\t\twidth: 2rem;\n\t\t\tborder-radius: 50%;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&__outline {\n\t\t\tcontent: '';\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\theight: 2rem;\n\t\t\twidth: 2rem;\n\t\t\tborder-radius: 50%;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n}\n\n//Styling right side\n.rightside {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: var(--color-white);\n\tmin-height: 100vh;\n\tpadding-top: 2rem;\n\tpadding-bottom: 2rem;\n\n\t@media only screen and (max-width: 56.25em) {\n\t\tbackground-color: var(--color-light);\n\t\tmin-height: auto;\n\t}\n\n\t&__back {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tfont-size: 4.5rem;\n\t\tcolor: var(--color-primary);\n\t\tmargin: 2rem 0;\n\t\tcursor: pointer;\n\t\t\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary-4);\n\t\t}\n\t}\n}\n\n.logintext {\n\t&__center {\n\t\ttext-align: center;\n\t}\n\n\t&__title {\n\t\tfont-size: var(--default-font-subtitle);\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary);\n\t\tline-height: 3rem;\n\t}\n\n\t&__p {\n\t\tfont-size: var(--default-font-small);\n\t\tfont-weight: 400;\n\n\t\tline-height: 1.7rem;\n\t\tmargin-top: 2rem;\n\t\tmargin-bottom: 3rem;\n\t}\n}\n\n//FORM side\n.form {\n\tdisplay: block;\n\n\t&__group:not(:last-child) {\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__pin__input {\n\t\tfont-size: var(--default-font-size);\n\t\tfont-family: inherit;\n\t\tcolor: var(--color-grey);\n\t\twidth: 6rem;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder: 1px solid var(--color-dark);\n\t\tdisplay: block;\n\t\ttext-align: center;\n\n\t\t&:focus,\n\t\t&:focus-visible,\n\t\t&:focus-within {\n\t\t\tcolor: var(--color-dark);\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t}\n\t}\n\n\t&__input {\n\t\tfont-size: var(--default-font-size);\n\t\tfont-family: inherit;\n\t\tcolor: var(--color-grey);\n\t\tpadding-left: 2rem;\n\t\twidth: 38rem;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder: 1px solid var(--color-dark);\n\t\tdisplay: block;\n\n\t\t&:focus,\n\t\t&:focus-visible,\n\t\t&:focus-within {\n\t\t\tcolor: var(--color-dark);\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t}\n\t}\n\n\t&__label {\n\t\tfont-size: var(--default-font-small);\n\t\tfont-family: inherit;\n\t\tpadding-left: 2rem;\n\t}\n}\n\n// When form is filled\n\n.filled {\n\tcolor: var(--color-dark);\n}\n\n//otp styles\n.otp__group {\n\tdisplay: flex;\n\tgap: 2rem;\n\tmargin-top: 1rem;\n}\n\n// button style\nbutton {\n\tfont-family: 'Montserrat', sans-serif;\n\tfont-size: var(--default-font-size);\n\tdisplay: flex;\n\tbackground-color: transparent;\n\tborder: none;\n}\n\n.btn {\n\tpadding: 1.9rem 2.2rem;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-decoration: none;\n\tfont-weight: 700;\n\tborder-radius: 1rem;\n\tcursor: pointer;\n\n\t&__outline {\n\t\tborder: 1px solid var(--color-dark);\n\t\tmargin-right: 2.3rem;\n\t\tcolor: var(--color-dark);\n\n\t\t&:hover {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t&__default {\n\t\tbackground-color: var(--color-primary)-2;\n\t\tcolor: var(--color-white);\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary)-4;\n\t\t}\n\t}\n\n\t&__default_38 {\n\t\tbackground-color: var(--color-primary)-2;\n\t\tcolor: var(--color-white);\n\t\twidth: 38rem;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary)-4;\n\t\t}\n\t}\n\n\t&__icon {\n\t\theight: 2.2rem;\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__form {\n\t\tbackground-color: var(--color-primary)-2;\n\t\tcolor: var(--color-white);\n\t\twidth: 100%;\n\t\tmargin-top: 2rem;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary)-4;\n\t\t}\n\t}\n}\n\n.accent {\n\tfont-size: var(--default-font-small);\n\tfont-weight: 700;\n\ttext-align: end;\n\tcursor: pointer;\n}\n\n.clickable {\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n}\n\n.emphasized {\n\tcolor: var(--color-primary);\n\tfont-size: var(--default-font-size);\n}\n\n//Color styles\n.color__primary {\n\tcolor: var(--color-primary);\n}\n\n//Random usable styles\n.mt_40 {\n\tmargin-top: 4rem;\n}\n\n.mt_30 {\n\tmargin-top: 3rem;\n}\n\n.mb_30 {\n\tmargin-bottom: 3rem;\n}\n\n.mb_10 {\n\tmargin-bottom: 1rem;\n}\n\n//Errors\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n\tmax-width: 38rem;\n}\n\n// Success\n.success {\n\t&__h3 {\n\t\tcolor: var(--color-success);\n\t\tfont-size: var(--default-font-h3);\n\t\tfont-weight: 700;\n\t\tline-height: 3.5rem;\n\t}\n}\n\n//Password Image change\n.pw__img {\n\tmax-width: 25rem;\n}\n\n.account {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t& > * {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__owner {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__employee {\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__desc {\n\t\tfont-size: var(--default-font-small);\n\t\twidth: 38rem;\n\t\ttext-align: center;\n\t\tmargin-bottom: 3rem;\n\n\t\tspan {\n\t\t\tfont-weight: 700;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n}\n\n//sign up referral code input field\ninput:disabled {\n\tcursor: not-allowed;\n\tbackground-color: var(--color-grey-3);\n}\n\n//used in new beneficiary\n.checkbox{\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin: 1rem 0 2rem 0;\n\twidth: 100%;\n\n\t&__group {\n\t\talign-self: center;\n\t\twidth: 100%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Login_container__SjpRI`,
	"leftside": `Login_leftside__FS9NJ`,
	"logo": `Login_logo__VaYjm`,
	"slider": `Login_slider__5QHiN`,
	"slider__img": `Login_slider__img__WIdf-`,
	"slider__title": `Login_slider__title__0q4pM`,
	"slider__icon": `Login_slider__icon__dKsrN`,
	"slider__icon__default": `Login_slider__icon__default__tKz63`,
	"slider__icon__outline": `Login_slider__icon__outline__-02XF`,
	"rightside": `Login_rightside__nhkW7`,
	"rightside__back": `Login_rightside__back__W5kq5`,
	"logintext__center": `Login_logintext__center__DbD-L`,
	"logintext__title": `Login_logintext__title__0DSKp`,
	"logintext__p": `Login_logintext__p__wb-Oy`,
	"form": `Login_form__-A4-1`,
	"form__group": `Login_form__group__zG+o7`,
	"form__pin__input": `Login_form__pin__input__MQfFP`,
	"form__input": `Login_form__input__jOQyW`,
	"form__label": `Login_form__label__r9UNY`,
	"filled": `Login_filled__w6sCg`,
	"otp__group": `Login_otp__group__1dHw7`,
	"btn": `Login_btn__rkmne`,
	"btn__outline": `Login_btn__outline__584VG`,
	"btn__default": `Login_btn__default__NHTqN`,
	"btn__default_38": `Login_btn__default_38__eMqt6`,
	"btn__icon": `Login_btn__icon__1VNGL`,
	"btn__form": `Login_btn__form__PU5Hx`,
	"accent": `Login_accent__Q9jN6`,
	"clickable": `Login_clickable__Q+uUi`,
	"emphasized": `Login_emphasized__EBSzU`,
	"color__primary": `Login_color__primary__Eifid`,
	"mt_40": `Login_mt_40__pCmrf`,
	"mt_30": `Login_mt_30__HAf0E`,
	"mb_30": `Login_mb_30__dKnxY`,
	"mb_10": `Login_mb_10__mYSNi`,
	"error": `Login_error__TObdD`,
	"success__h3": `Login_success__h3__89soV`,
	"pw__img": `Login_pw__img__FFZWs`,
	"account": `Login_account__DDsxO`,
	"account__owner": `Login_account__owner__pfifW`,
	"account__owner_b": `Login_account__owner_b__jr+35`,
	"account__employee": `Login_account__employee__D4DJD`,
	"account__employee_b": `Login_account__employee_b__GFTDs`,
	"account__desc": `Login_account__desc__tPTFg`,
	"checkbox": `Login_checkbox__QdBqA`,
	"checkbox__group": `Login_checkbox__group__fMZqQ`
};
export default ___CSS_LOADER_EXPORT___;
